import React, { useState } from 'react';
import {
  FaSearch,
  FaPlus,
  FaExclamationTriangle,
  FaEye,
  FaEdit,
  FaTrash,
  FaHistory,
} from 'react-icons/fa';
import '../styles/ResourceDashboard.css';
import ResourceUpdate from './ResourceUpdate';
import ResourceView from './ResourceView';
import ResourceHistory from './ResourceHistory';

const ResourceDashboard = () => {
  const [showResourceUpdate, setShowResourceUpdate] = useState(false);
  const [selectedResource, setSelectedResource] = useState(null);
  const [showResourceHistory, setShowResourceHistory] = useState(false);

  const stockAlerts = [
    'Glass Cleaner: Only 5 ltr left.',
    'Tissue Paper: Only 10 packs left.',
    'Detergent: Only 3 kg left.',
    'Sanitizer: Only 2 bottles left.',
  ];

  const resourceData = [
    {
      date: '2025-09-25',
      category: 'Cleaning',
      code: 'CL-001',
      item: 'Glass Cleaner',
      quantity: '5 ltr',
      project: 'Office Maintenance',
      remark: 'Urgent reorder needed',
    },
    {
      date: '2025-09-24',
      category: 'Supplies',
      code: 'SP-002',
      item: 'Tissue Paper',
      quantity: '10 packs',
      project: 'Pantry',
      remark: 'Monitor usage',
    },
  ];

  return (
    <div className="resource-update-dashboard-container">
      {/* Top Heading */}
      <h2 className="resource-update-dashboard-title">
        Resources Update History
      </h2>

      {/* Search and Buttons */}
      <div className="resource-update-dashboard-toolbar">
        <div className="resource-update-dashboard-search-box">
          <input type="text" placeholder="Search..." />
          <FaSearch className="resource-update-dashboard-icon" />
        </div>
        <div className="resource-update-dashboard-toolbar-actions">
          <button
            className="resource-update-dashboard-btn resource-update-dashboard-history"
            onClick={() => setShowResourceHistory(true)}
          >
            <FaHistory /> History Detail
          </button>
          <button
            className="resource-update-dashboard-btn resource-update-dashboard-add"
            onClick={() => setShowResourceUpdate(true)}
          >
            <FaPlus /> Add Resource Update
          </button>
        </div>
      </div>

      {/* Low Stock Alert */}
      <div className="resource-update-dashboard-alert-box">
        <div className="resource-update-dashboard-alert-header">
          <FaExclamationTriangle className="resource-update-dashboard-alert-icon" />
          <span className="resource-update-dashboard-alert-text">
            Low Stock Alert
          </span>
        </div>
        <ul className="resource-update-dashboard-alert-list">
          {stockAlerts.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
      </div>

      {/* Resource Table */}
      <table className="resource-update-dashboard-table">
        <thead>
          <tr>
            <th>Project</th>
             <th>Category</th>
             <th>Item</th>
                 <th>Item Code</th>
                 <th>Quantity</th>
            
            <th>Remark</th>
            <th>Date</th>
           
        
            
            
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {resourceData.map((row, idx) => (
            <tr key={idx}>
               <td>{row.project}</td>
               <td>{row.category}</td>
               <td>{row.item}</td>
                <td>{row.code}</td>
              
              <td>{row.quantity}</td>
             
              <td>{row.remark}</td>
              <td>{row.date}</td>
              
             
              <td className="resource-update-dashboard-actions">
                <FaEye
                  className="resource-update-dashboard-view"
                  onClick={() => setSelectedResource(row)}
                  style={{ cursor: 'pointer' }}
                />
                <FaEdit className="resource-update-dashboard-edit" />
                <FaTrash className="resource-update-dashboard-delete" />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Resource Update Overlay */}
      {showResourceUpdate && (
        <ResourceUpdate onClose={() => setShowResourceUpdate(false)} />
      )}

      {/* Resource View Overlay */}
      {selectedResource && (
        <ResourceView
          data={selectedResource}
          onClose={() => setSelectedResource(null)}
        />
      )}

      {/* Resource History Overlay */}
      {showResourceHistory && (
        <ResourceHistory
          data={resourceData}
          onClose={() => setShowResourceHistory(false)}
        />
      )}
    </div>
  );
};

export default ResourceDashboard;
